var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--circle-9", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading spin-1" }, [
      _c("div", { staticClass: "loading spin-2" }, [
        _c("div", { staticClass: "loading spin-3" }, [
          _c("div", { staticClass: "loading spin-4" }, [
            _c("div", { staticClass: "loading spin-5" }, [
              _c("div", { staticClass: "loading spin-6" }),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }